<template>
  <list-main />
</template>

<script>
import ListMain from '@/components/notebook/ListMain.vue'

export default {
  title: 'notebook list',
  components: {
    ListMain,
  },
  data: () => ({}),
}
</script>
